// axios
import axios from "axios";
import router from "@/router/index";

const token = localStorage.getItem("api_token") ?? null;
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_URL ?? "http://localhost.api",
  // timeout: 1000,
  headers: { Authorization: `Bearer ${token}` }
});
axiosIns.interceptors.request.use(req => {
  req.headers = { ...req.headers, Authorization: 'Bearer ' +  localStorage.getItem("api_token")}
  return req;
})
axiosIns.interceptors.response.use(
  response => response,
  error => {
    const errorStatus = error?.response?.status ?? null;
    if (errorStatus === 401 || errorStatus === 403) {
      localStorage.removeItem("api_token");
      router.push("/login").catch(() => {});
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
export default axiosIns;
